import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { GAnalyticsService } from '../../../services/g-analytics.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'language-menu',
  templateUrl: './language-menu.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'languageMenu',
})
export class LanguageMenuComponent implements OnInit, OnDestroy {
  currentLang = localStorage.getItem('lang') || 'en';
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  // Language options
  languages = [
    { id: 'en', label: 'English', nativeLabel: 'English', icon: 'mat_solid:language' },
    { id: 'ar', label: 'Arabic', nativeLabel: 'العربية', icon: 'mat_solid:language' },
    { id: 'ru', label: 'Russian', nativeLabel: 'Русский', icon: 'mat_solid:language' },
  ];

  get currentLanguage() {
    return this.languages.find((lang) => lang.id === this.currentLang) || this.languages[0];
  }

  get availableLanguages() {
    return this.languages.filter((lang) => lang.id !== this.currentLang);
  }

  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private googleServices: GAnalyticsService,
    private _transloco: TranslocoService,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Update current language from localStorage
    this.currentLang = localStorage.getItem('lang') || 'en';
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Switch language
   */
  switchLanguage(lang: string): void {
    if (lang === this.currentLang) {
      return;
    }

    this.googleServices.setEvent('LanguageSelection_Settings', 'Authentication');

    // Track specific language selection
    const langMap: { [key: string]: string } = {
      en: 'LanguageSelection_English_Settings',
      ar: 'LanguageSelection_Arabic_Settings',
      ru: 'LanguageSelection_Russian_Settings',
    };
    if (langMap[lang]) {
      this.googleServices.setEvent(langMap[lang], 'Authentication');
    }

    this.currentLang = lang;
    localStorage.setItem('lang', lang);

    // Reload the page
    // Get the current route URL without query parameters
    const urlWithoutQueryParams = this._router.url.split('?')[0];

    // Navigate to the current route without query parameters
    this._router.navigateByUrl(urlWithoutQueryParams);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}
